const countryData = {
    us: {
      name: 'United States',
      content: 'In the United States, DUNS Numbers are widely used for government contracts and are required for businesses seeking federal contracts or grants. As a unique nine-digit identifier assigned by Dun & Bradstreet, the DUNS Number has become the standard for business identification across federal agencies, financial institutions, and major corporations.',
      specificInfo: 'The U.S. Small Business Administration (SBA) previously provided free DUNS Number registration through their partnership with D&B. Today, businesses can obtain their DUNS Number directly through D&B or use free lookup services like ours to find existing DUNS Numbers for any registered U.S. business.',
      benefits: [
        'Enhance your business credibility in the United States market',
        'Access to government contracts and tenders',
        'Easier verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
      ],
      industries: [
        'Federal contractors and subcontractors',
        'Healthcare providers applying for Medicare/Medicaid',
        'Educational institutions seeking federal grants',
        'App developers publishing on Google Play and Apple App Store',
        'Businesses applying for SBA loans',
        'Companies participating in supply chain networks',
      ],
      faqs: [
        {
          question: 'Is a DUNS Number free to obtain in the United States?',
          answer: 'Yes, obtaining a DUNS Number is free for U.S. businesses. However, looking up an existing DUNS Number through official D&B channels often requires a paid subscription. Our free lookup service allows you to find any company\'s DUNS Number at no cost.'
        },
        {
          question: 'How long does it take to get a DUNS Number?',
          answer: 'Standard registration takes approximately 30 business days. Expedited processing is available for a fee and typically completes within 1-2 business days.'
        },
        {
          question: 'Do I need a DUNS Number as an app developer?',
          answer: 'Yes, both Google Play and Apple App Store require a DUNS Number for organization developer accounts. This is part of their business verification process to ensure legitimate businesses are publishing apps.'
        },
      ],
      titles: {
        benefits: 'Benefits of Having a DUNS Number in the United States',
        usage: 'How to Use Your DUNS Number in the United States',
        getting: 'Getting a DUNS Number in the United States',
        industries: 'Industries That Require DUNS Numbers in the US',
        faqs: 'Frequently Asked Questions',
      },
    },
    fr: {
      name: 'France',
      content: 'En France, les numéros DUNS sont largement utilisés pour les contrats gouvernementaux et sont essentiels pour les entreprises qui cherchent à développer leurs activités à l\'international.',
      specificInfo: 'Les entreprises françaises peuvent obtenir un numéro DUNS auprès de Dun & Bradstreet France.',
      benefits: [
        'Améliorez la crédibilité de votre entreprise sur le marché français',
        'Accédez aux contrats et appels d\'offres gouvernementaux',
        'Simplifiez la vérification par des partenaires potentiels',
        'Améliorez vos chances d\'obtenir des prêts commerciaux',
        'Obligatoire pour les développeurs d\'applications Google Play et iOS',
      ],
      usage: [
        'S\'inscrire aux contrats gouvernementaux',
        'Établir un crédit commercial',
        'Vérifier l\'identité de votre entreprise auprès de partenaires',
        'Demander des prêts ou des lignes de crédit',
        'Enregistrer des applications sur Google Play et l\'App Store d\'Apple',
      ],
      lookupLink: 'Pour plus d\'informations ou pour rechercher votre numéro DUNS, visitez notre page de recherche DUNS.',
      titles: {
        benefits: 'Avantages d\'avoir un numéro DUNS en France',
        usage: 'Comment utiliser votre numéro DUNS en France',
        getting: 'Obtenir un numéro DUNS en France',
      },
    },
    de: {
      name: 'Germany',
      content: 'In Deutschland werden DUNS-Nummern häufig für staatliche Aufträge verwendet und sind erforderlich für Unternehmen, die Bundesverträge oder Zuschüsse anstreben.',
      specificInfo: 'Deutsche Unternehmen können eine DUNS-Nummer über Dun & Bradstreet Deutschland erhalten.',
      benefits: [
        'Erhöhen Sie die Glaubwürdigkeit Ihres Unternehmens auf dem deutschen Markt',
        'Zugang zu staatlichen Aufträgen und Ausschreibungen',
        'Einfachere Überprüfung durch potenzielle Partner und Kunden',
        'Verbesserte Chancen auf Geschäftskredite',
        'Erforderlich für Entwickler von Google Play Android- und iOS-Apps',
      ],
      usage: [
        'Anmeldung für staatliche Aufträge',
        'Aufbau von Geschäftskredit',
        'Überprüfung der Unternehmensidentität bei potenziellen Partnern',
        'Beantragung von Darlehen oder Kreditlinien',
        'Registrierung von Apps bei Google Play und dem Apple App Store',
      ],
      lookupLink: 'Für weitere Informationen oder um Ihre DUNS-Nummer zu suchen, besuchen Sie unsere DUNS-Suchseite.',
      titles: {
        benefits: 'Vorteile eines DUNS-Nummer in Deutschland',
        usage: 'So verwenden Sie Ihre DUNS-Nummer in Deutschland',
        getting: 'Einen DUNS-Nummer in Deutschland erhalten',
      },
    },
    jp: {
      name: 'Japan',
      content: '日本では、DUNS番号は政府の契約に広く使用されており、企業が国際的に展開するために不可欠です。',
      specificInfo: '日本の企業は、ダン＆ブラッドストリートジャパンを通じてDUNS番号を取得できます。',
      benefits: [
        '日本市場でのビジネスの信頼性を高める',
        '政府契約や入札にアクセスする',
        '潜在的なパートナーや顧客による容易な確認',
        'ビジネスローンや信用を得る可能性の向上',
        'Google Play AndroidおよびiOSアプリ開発者に必要',
      ],
      usage: [
        '政府契約に登録する',
        'ビジネスクレジットを確立する',
        '潜在的なパートナーに対するビジネスの身元を確認する',
        '融資や信用枠を申請する',
        'Google PlayおよびApple App Storeにアプリを登録する',
      ],
      lookupLink: '詳細情報やDUNS番号の検索は、DUNS検索ページをご覧ください。',
      titles: {
        benefits: '日本におけるDUNS番号の利点',
        usage: '日本でのDUNS番号の使い方',
        getting: '日本でDUNS番号を取得する',
      },
    },
    au: {
      name: 'Australia',
      content: 'In Australia, DUNS Numbers are a cornerstone of business identification for government procurement and international trade. Australian businesses seeking to work with federal or state government agencies, or those expanding into Asia-Pacific and global markets, rely on DUNS Numbers for credibility and verification. The Australian Business Register (ABR) works alongside DUNS Numbers to provide comprehensive business identification.',
      specificInfo: 'Australian businesses can obtain a DUNS Number through Dun & Bradstreet Australia. Many Australian companies registered with ASIC already have a DUNS Number assigned. Our free lookup tool lets you instantly check if your ABN-registered business already has a DUNS Number on file.',
      benefits: [
        'Enhance your business credibility in the Australian market',
        'Access to federal and state government tenders',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
        'Gateway to Asia-Pacific business opportunities',
      ],
      usage: [
        'Register for government contracts and tenders',
        'Establish business credit history',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
        'Expand into international markets',
      ],
      industries: [
        'Federal and state government contractors',
        'Mining and resources sector',
        'Technology and software companies',
        'App developers and digital services',
        'Healthcare and aged care providers',
        'Construction and infrastructure',
      ],
      faqs: [
        {
          question: 'Is a DUNS Number the same as an ABN?',
          answer: 'No, they are different identifiers. Your Australian Business Number (ABN) is issued by the Australian government, while the DUNS Number is assigned by Dun & Bradstreet for global business identification purposes.'
        },
        {
          question: 'How can I find my Australian business DUNS Number for free?',
          answer: 'Use our free DUNS lookup tool to search for your business by name. We are the only globally available free DUNS lookup service, saving you from expensive subscription fees.'
        },
        {
          question: 'Do Australian app developers need a DUNS Number?',
          answer: 'Yes, if you want to publish apps as an organization on Google Play or Apple App Store, you will need a valid DUNS Number for your business entity.'
        },
      ],
      titles: {
        benefits: 'Benefits of Having a DUNS Number in Australia',
        usage: 'How to Use Your DUNS Number in Australia',
        getting: 'Getting a DUNS Number in Australia',
        industries: 'Industries Requiring DUNS Numbers in Australia',
        faqs: 'Frequently Asked Questions',
      },
    },
    gb: {
      name: 'United Kingdom',
      content: 'In the United Kingdom, DUNS Numbers are essential for businesses operating in both domestic and international markets. The UK government and major corporations rely on DUNS Numbers for supplier verification, procurement processes, and business credit assessments. With Brexit, having a properly registered DUNS Number has become even more critical for UK businesses trading with EU partners.',
      specificInfo: 'UK businesses can obtain a DUNS Number through Dun & Bradstreet UK. Many UK companies already have a DUNS Number without realizing it, as D&B compiles business data from Companies House and other public sources. Use our free lookup tool to check if your business already has a DUNS Number.',
      benefits: [
        'Enhance your business credibility in the UK market',
        'Access to government contracts and tenders',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
        'Essential for post-Brexit EU trade relationships',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
        'Participate in global supply chains',
      ],
      industries: [
        'Government contractors and suppliers',
        'Fintech and financial services companies',
        'App developers and software publishers',
        'Export-oriented businesses',
        'Healthcare and pharmaceutical companies',
        'Construction and infrastructure firms',
      ],
      faqs: [
        {
          question: 'Do UK companies automatically have a DUNS Number?',
          answer: 'Many UK companies registered with Companies House are automatically assigned a DUNS Number by D&B through their data compilation process. Use our free lookup tool to check if your company already has one.'
        },
        {
          question: 'Is a DUNS Number the same as a Companies House number?',
          answer: 'No, they are different identifiers. Your Companies House number is issued by the UK government, while the DUNS Number is assigned by Dun & Bradstreet for global business identification.'
        },
        {
          question: 'Do I need a DUNS Number to publish apps in the UK?',
          answer: 'Yes, both Google Play and Apple App Store require a DUNS Number for organization developer accounts, regardless of your country of registration.'
        },
      ],
      titles: {
        benefits: 'Benefits of Having a DUNS Number in the United Kingdom',
        usage: 'How to Use Your DUNS Number in the United Kingdom',
        getting: 'Getting a DUNS Number in the United Kingdom',
        industries: 'Industries Requiring DUNS Numbers in the UK',
        faqs: 'Frequently Asked Questions',
      },
    },
    ca: {
      name: 'Canada',
      content: 'In Canada, DUNS Numbers play a vital role in business identification for both federal and provincial government contracts. Canadian businesses engaged in cross-border trade with the United States benefit significantly from having a DUNS Number, as it is recognized by the U.S. federal government and major corporations on both sides of the border.',
      specificInfo: 'Canadian businesses can obtain a DUNS Number through Dun & Bradstreet Canada. Many established Canadian companies already have a DUNS Number in the D&B database. Our free lookup service allows you to quickly check if your business has an existing DUNS Number without any registration fees.',
      benefits: [
        'Enhance your business credibility in the Canadian market',
        'Access to federal and provincial government contracts',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
        'Essential for US-Canada cross-border business relationships',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
        'Facilitate trade with US partners',
      ],
      industries: [
        'Federal and provincial government contractors',
        'Technology and software companies',
        'Manufacturing and export businesses',
        'App developers and digital publishers',
        'Healthcare and life sciences',
        'Natural resources and energy sector',
      ],
      faqs: [
        {
          question: 'Do Canadian businesses need a DUNS Number for US contracts?',
          answer: 'Yes, Canadian businesses seeking US federal contracts must have a DUNS Number as it is required for registration in the US System for Award Management (SAM).'
        },
        {
          question: 'Is there a cost to look up my Canadian DUNS Number?',
          answer: 'No, our free DUNS lookup service allows you to find any Canadian company\'s DUNS Number at no cost. This is the only globally available free DUNS lookup service.'
        },
        {
          question: 'How do I find my company\'s DUNS Number in Canada?',
          answer: 'Use our free lookup tool above to search for your company by name. Many Canadian businesses already have a DUNS Number assigned through D&B\'s data compilation process.'
        },
      ],
      titles: {
        benefits: 'Benefits of Having a DUNS Number in Canada',
        usage: 'How to Use Your DUNS Number in Canada',
        getting: 'Getting a DUNS Number in Canada',
        industries: 'Industries Requiring DUNS Numbers in Canada',
        faqs: 'Frequently Asked Questions',
      },
    },
    cn: {
      name: 'China',
      content: '在中国，DUNS号码广泛用于政府合同，对于寻求联邦合同或补助金的企业来说是必需的。',
      specificInfo: '中国企业可以通过邓白氏中国获取DUNS号码。',
      benefits: [
        '提升您在中国市场的商业信誉',
        '获取政府合同和招标',
        '简化潜在合作伙伴和客户的验证过程',
        '提高获得商业贷款和信用的机会',
        'Google Play Android和iOS应用开发者必需',
      ],
      usage: [
        '注册政府合同',
        '建立商业信用',
        '向潜在合作伙伴验证您的商业身份',
        '申请贷款或信用额度',
        '在Google Play和Apple App Store上注册应用',
      ],
      lookupLink: '欲了解更多信息或查询您的DUNS号码，请访问我们的DUNS查询页面。',
      titles: {
        benefits: '在中国拥有DUNS号码的好处',
        usage: '如何在中国使用您的DUNS号码',
        getting: '在中国获取DUNS号码',
      },
    },
    in: {
      name: 'India',
      content: 'In India, DUNS Numbers are essential for businesses seeking government contracts and for establishing credibility in the Indian market.',
      specificInfo: 'Indian businesses can obtain a DUNS Number through Dun & Bradstreet India.',
      benefits: [
        'Enhance your business credibility in the Indian market',
        'Access to government contracts and tenders',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
      ],
      lookupLink: 'For more information or to look up your DUNS Number, visit our DUNS Lookup page.',
      titles: {
        benefits: 'Benefits of Having a DUNS Number in India',
        usage: 'How to Use Your DUNS Number in India',
        getting: 'Getting a DUNS Number in India',
      },
    },
    br: {
      name: 'Brazil',
      content: 'No Brasil, os números DUNS são amplamente utilizados para contratos governamentais e são essenciais para empresas que buscam expandir seus negócios no mercado brasileiro.',
      specificInfo: 'Empresas brasileiras podem obter um número DUNS através da Dun & Bradstreet Brasil.',
      benefits: [
        'Melhore a credibilidade do seu negócio no mercado brasileiro',
        'Acesso a contratos e licitações governamentais',
        'Processo de verificação simplificado para parceiros e clientes potenciais',
        'Aumenta as chances de garantir empréstimos comerciais e crédito',
        'Necessário para desenvolvedores de aplicativos Google Play Android e iOS',
      ],
      usage: [
        'Registrar-se para contratos governamentais',
        'Estabelecer crédito comercial',
        'Verificar a identidade do seu negócio para parceiros potenciais',
        'Solicitar empréstimos ou linhas de crédito',
        'Registrar aplicativos no Google Play e na Apple App Store',
      ],
      lookupLink: 'Para mais informações ou para consultar seu número DUNS, visite nossa página de Pesquisa DUNS.',
      titles: {
        benefits: 'Benefícios de Ter um Número DUNS no Brasil',
        usage: 'Como Usar Seu Número DUNS no Brasil',
        getting: 'Obtendo um Número DUNS no Brasil',
      },
    },
    mx: {
      name: 'Mexico',
      content: 'En México, los números DUNS son ampliamente utilizados para contratos gubernamentales y son esenciales para las empresas que buscan expandirse en el mercado mexicano.',
      specificInfo: 'Las empresas mexicanas pueden obtener un número DUNS a través de Dun & Bradstreet México.',
      benefits: [
        'Mejore la credibilidad de su negocio en el mercado mexicano',
        'Acceso a contratos y licitaciones gubernamentales',
        'Proceso de verificación simplificado para socios y clientes potenciales',
        'Mejores oportunidades para asegurar préstamos comerciales y crédito',
        'Requerido para desarrolladores de aplicaciones Google Play Android y iOS',
      ],
      usage: [
        'Registrarse para contratos gubernamentales',
        'Establecer crédito comercial',
        'Verificar la identidad de su negocio para socios potenciales',
        'Solicitar préstamos o líneas de crédito',
        'Registrar aplicaciones en Google Play y Apple App Store',
      ],
      lookupLink: 'Para más información o para consultar su número DUNS, visite nuestra página de Búsqueda DUNS.',
      titles: {
        benefits: 'Beneficios de Tener un Número DUNS en México',
        usage: 'Cómo Usar Su Número DUNS en México',
        getting: 'Obteniendo un Número DUNS en México',
      },
    },
    za: {
      name: 'South Africa',
      content: 'In South Africa, DUNS Numbers are essential for businesses seeking government contracts and for establishing credibility in the South African market.',
      specificInfo: 'South African businesses can obtain a DUNS Number through Dun & Bradstreet South Africa.',
      benefits: [
        'Enhance your business credibility in the South African market',
        'Access to government contracts and tenders',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
      ],
      lookupLink: 'For more information or to look up your DUNS Number, visit our DUNS Lookup page.',
      titles: {
        benefits: 'Benefits of Having a DUNS Number in South Africa',
        usage: 'How to Use Your DUNS Number in South Africa',
        getting: 'Getting a DUNS Number in South Africa',
      },
    },
    sg: {
      name: 'Singapore',
      content: 'In Singapore, DUNS Numbers are essential for businesses seeking government contracts and for establishing credibility in the Singaporean market.',
      specificInfo: 'Singaporean businesses can obtain a DUNS Number through Dun & Bradstreet Singapore.',
      benefits: [
        'Enhance your business credibility in the Singaporean market',
        'Access to government contracts and tenders',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
      ],
      lookupLink: 'For more information or to look up your DUNS Number, visit our DUNS Lookup page.',
      titles: {
        benefits: 'Benefits of Having a DUNS Number in Singapore',
        usage: 'How to Use Your DUNS Number in Singapore',
        getting: 'Getting a DUNS Number in Singapore',
      },
    },
    ae: {
      name: 'United Arab Emirates',
      content: 'In the United Arab Emirates, DUNS Numbers are essential for businesses seeking government contracts and for establishing credibility in the UAE market.',
      specificInfo: 'UAE businesses can obtain a DUNS Number through Dun & Bradstreet UAE.',
      benefits: [
        'Enhance your business credibility in the UAE market',
        'Access to government contracts and tenders',
        'Simplified verification process for potential partners and clients',
        'Improved chances of securing business loans and credit',
        'Required for Google Play Android and iOS app developers',
      ],
      usage: [
        'Register for government contracts',
        'Establish business credit',
        'Verify your business identity to potential partners',
        'Apply for loans or lines of credit',
        'Register apps on Google Play and the Apple App Store',
      ],
      lookupLink: 'For more information or to look up your DUNS Number, visit our DUNS Lookup page.',
      titles: {
        benefits: 'Benefits of Having a DUNS Number in the United Arab Emirates',
        usage: 'How to Use Your DUNS Number in the United Arab Emirates',
        getting: 'Getting a DUNS Number in the United Arab Emirates',
      },
    },
    nl: {
      name: 'Netherlands',
      content: 'In Nederland worden DUNS-nummers veel gebruikt voor overheidscontracten en zijn essentieel voor bedrijven die hun activiteiten internationaal willen uitbreiden.',
      specificInfo: 'Nederlandse bedrijven kunnen een DUNS-nummer verkrijgen via Dun & Bradstreet Nederland.',
      benefits: [
        'Verhoog de geloofwaardigheid van uw bedrijf op de Nederlandse markt',
        'Toegang tot overheidscontracten en aanbestedingen',
        'Vereenvoudigd verificatieproces voor potentiële partners en klanten',
        'Verbeterde kansen op het verkrijgen van bedrijfsleningen en krediet',
        'Vereist voor ontwikkelaars van Google Play Android- en iOS-apps',
      ],
      usage: [
        'Registreren voor overheidscontracten',
        'Zakelijke krediet opbouwen',
        'Verifieer uw bedrijfsidentiteit bij potentiële partners',
        'Aanvragen van leningen of kredietlijnen',
        'Apps registreren op Google Play en de Apple App Store',
      ],
      lookupLink: 'Voor meer informatie of om uw DUNS-nummer op te zoeken, bezoekt u onze DUNS Zoekpagina.',
      titles: {
        benefits: 'Voordelen van het Hebben van een DUNS-Nummer in Nederland',
        usage: 'Hoe U Uw DUNS-Nummer in Nederland Gebruikt',
        getting: 'Een DUNS-Nummer in Nederland Verkrijgen',
      },
    },
    it: {
      name: 'Italy',
      content: 'In Italia, i numeri DUNS sono ampiamente utilizzati per i contratti governativi e sono essenziali per le aziende che desiderano espandersi nel mercato italiano.',
      specificInfo: 'Le aziende italiane possono ottenere un numero DUNS tramite Dun & Bradstreet Italia.',
      benefits: [
        'Aumenta la credibilità della tua azienda nel mercato italiano',
        'Accesso a contratti e gare d\'appalto governativi',
        'Processo di verifica semplificato per potenziali partner e clienti',
        'Migliori possibilità di ottenere prestiti commerciali e crediti',
        'Richiesto per gli sviluppatori di app Google Play Android e iOS',
      ],
      usage: [
        'Registrarsi per contratti governativi',
        'Stabilire credito commerciale',
        'Verificare l\'identità della tua azienda per potenziali partner',
        'Richiedere prestiti o linee di credito',
        'Registrare app su Google Play e Apple App Store',
      ],
      lookupLink: 'Per ulteriori informazioni o per cercare il tuo numero DUNS, visita la nostra pagina di Ricerca DUNS.',
      titles: {
        benefits: 'Vantaggi di Avere un Numero DUNS in Italia',
        usage: 'Come Utilizzare il Tuo Numero DUNS in Italia',
        getting: 'Ottenere un Numero DUNS in Italia',
      },
    },
    es: {
      name: 'Spain',
      content: 'En España, los números DUNS son ampliamente utilizados para contratos gubernamentales y son esenciales para las empresas que buscan expandirse en el mercado español.',
      specificInfo: 'Las empresas españolas pueden obtener un número DUNS a través de Dun & Bradstreet España.',
      benefits: [
        'Mejore la credibilidad de su negocio en el mercado español',
        'Acceso a contratos y licitaciones gubernamentales',
        'Proceso de verificación simplificado para socios y clientes potenciales',
        'Mejores oportunidades para asegurar préstamos comerciales y crédito',
        'Requerido para desarrolladores de aplicaciones Google Play Android y iOS',
      ],
      usage: [
        'Registrarse para contratos gubernamentales',
        'Establecer crédito comercial',
        'Verificar la identidad de su negocio para socios potenciales',
        'Solicitar préstamos o líneas de crédito',
        'Registrar aplicaciones en Google Play y Apple App Store',
      ],
      lookupLink: 'Para más información o para consultar su número DUNS, visite nuestra página de Búsqueda DUNS.',
      titles: {
        benefits: 'Beneficios de Tener un Número DUNS en España',
        usage: 'Cómo Usar Su Número DUNS en España',
        getting: 'Obteniendo un Número DUNS en España',
      },
    },
    kr: {
      name: 'South Korea',
      content: '대한민국에서는 DUNS 번호가 정부 계약에 널리 사용되며, 한국 시장에서의 신뢰성을 구축하는 데 필수적입니다.',
      specificInfo: '한국 기업은 Dun & Bradstreet Korea를 통해 DUNS 번호를 획득할 수 있습니다.',
      benefits: [
        '한국 시장에서의 비즈니스 신뢰성 향상',
        '정부 계약 및 입찰에 접근',
        '잠재적인 파트너 및 고객을 위한 간편한 검증 과정',
        '비즈니스 대출 및 신용 확보 가능성 향상',
        'Google Play Android 및 iOS 앱 개발자 필수',
      ],
      usage: [
        '정부 계약에 등록',
        '비즈니스 신용 확립',
        '잠재적인 파트너에게 비즈니스 신원을 확인',
        '대출 또는 신용 한도 신청',
        'Google Play 및 Apple App Store에 앱 등록',
      ],
      lookupLink: '자세한 정보나 DUNS 번호를 조회하려면, 저희 DUNS 조회 페이지를 방문하세요.',
      titles: {
        benefits: '대한민국에서 DUNS 번호를 보유하는 이점',
        usage: '대한민국에서 DUNS 번호를 사용하는 방법',
        getting: '대한민국에서 DUNS 번호 획득',
      },
    },
  };
  
  export default countryData;
